<template>
    <div class="mb-4">
        <v-card-title class="px-0 pb-1">Фильтр</v-card-title>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="9">
                        <v-row dense>
                            <v-col cols="6" md="4" sm="4">
                                <custom-input-text
                                        clearable
                                        hide-details
                                        label="Ф.И.О"
                                        v-model="filter.name"
                                ></custom-input-text>
                            </v-col>
                            <v-col cols="6" md="4" sm="4">
                                <custom-input-text
                                        clearable
                                        hide-details
                                        label="Кредит номер"
                                        v-model="filter.credit_number"
                                ></custom-input-text>
                            </v-col>
                            <v-col cols="12" md="4" sm="4">
                                <custom-select
                                        :items="DEBT_STATUS"
                                        clearable
                                        hide-details
                                        item-text="text"
                                        item-value="value"
                                        label="Задолженность"
                                        v-model="filter.debts"
                                ></custom-select>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col>
                        <v-row dense>
                            <v-col>
                                <v-btn @click="collapse = !collapse" style="min-width: auto" width="100%">
                                    <v-icon :class='{ show: collapse }' color="primary" style='transition: .3s all'>
                                        $expand
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn @click="clear" color="error" style="min-width: auto" width="100%">
                                    <v-icon>fas fa-times</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn @click="filterList" color="primary"
                                       style="min-width: auto"
                                       width="100%">
                                    <v-icon>fas fa-search</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <download-excel-credits :filter="filter" width="100%"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <div style='transition: .5s all' v-if="collapse">
                    <v-row dense>
                        <v-col cols="6" md="3">
                            <custom-input-text
                                    clearable
                                    hide-details
                                    always-uppercase
                                    v-mask="'AA#######'"
                                    label="Паспорт серия и номер (AA1234567)"
                                    v-model="filter.passport"
                            ></custom-input-text>
                        </v-col>
                        <v-col cols="6" md="3">
                            <custom-input-text
                                    clearable
                                    hide-details
                                    label="Телефон номер"
                                    v-model="filter.phone"
                            ></custom-input-text>
                        </v-col>
                        <v-col cols="6" md="3">
                            <custom-date-picker
                                    clearable
                                    hide-details
                                    label="Дата от"
                                    v-model="filter.from"
                            ></custom-date-picker>
                        </v-col>
                        <v-col cols="6" md="3">
                            <custom-date-picker
                                    clearable
                                    hide-details
                                    label="Дата до"
                                    v-model="filter.to"
                            ></custom-date-picker>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
	import {CREDIT_STATUS, DEBT_STATUS} from "@/utils/constants";
	import FilterTemplate from "@/components/ui/template-filter/TemplateFIlter";
	import DownloadExcelCredits from "@/components/credit/DonwloadExcelCreditsList";

	export default {
		name: 'credit-table-filter',
		components: {DownloadExcelCredits, FilterTemplate},
		props: {
			mkos: {
				type: Array
			}
		},
		data() {
			return {
				showingFilter: false,
				status: CREDIT_STATUS,
				DEBT_STATUS,
				autoPayment: [
					{
						name: 'Да',
						id: true,
					},
					{
						name: 'Нет',
						id: false,
					}
				],
				filter: {
					name: null,
					credit_number: null,
					phone: null,
					from: null,
					to: null,
					turn_autopayment: null,
					status: null,
					debts: null,
          passport: null
				},
				collapse: false
			}
		},
		methods: {
			filterList() {
				this.$emit('change', this.filter)
			},
			clear() {
				this.filter = {
					name: null,
					from: null,
					credit_number: null,
					phone: null,
					to: null,
					turn_autopayment: null,
					status: null,
          passport: null,
					debts: null
				}
				this.$emit('change', this.filter)
			}
		}
	}
</script>
<style scoped>
    .show {
        transform: rotate(180deg);
    }

    .min-width-auto {
        min-width: auto !important;
    }

</style>
